const readOnlyTheme = {
  [`
  & input[readonly],
  & *:disabled,
  & .form-control:disabled,
  & .flex-dropdown-root.disabled .flex-dropdown-wrapper .selection
`]: {
    // Handle calendar icon and display Radio and Checkbox icons
    '& + span:not([class*="checkboxIcon"]):not([class*="radioIcon"])': {
      display: 'none'
    },
    '& .caret': {
      display: 'none'
    },
    '& svg': {
      display: 'none'
    },
    '& ~ svg': {
      display: 'none'
    },
    background: 'none',
    border: 'none',
    boxShadow: 'none',
    padding: 0,
    textAlign: 'left'
  }
};

export default readOnlyTheme;
